import products from '../../api/products'

export default {
    namespaced: true,
    state: () => ({
        loading: false,
        items: []
    }),
    getters: {},
    actions: {
        getProducts ({ commit }, query) {
            commit('setLoading', true)
            return products.getProducts(query).then((response) => {
                commit('setItems', response.data.phones)
                commit('setLoading', false)
            })
        }
    },
    mutations: {
        setLoading (state, bool) {
            state.loading = bool
        },
        setItems (state, data) {
            state.items = data
        }
    }
}
